import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const AssetDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.AssetDetailPage })));
const AssetFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.AssetFormPage })));
const AssetListPage = lazy(() => import('./list-page').then((m) => ({ default: m.AssetListPage })));

export const assetRoutes: RouteObject[] = [
  {
    path: 'assets',
    handle: { crumb: 'Asset Registry' },
    children: [
      { index: true, element: <AssetListPage /> },
      { path: 'new', element: <AssetFormPage />, handle: { crumb: 'New asset' } },
      { path: ':id', element: <AssetDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Asset' } },
      { path: ':id/edit', element: <AssetFormPage />, handle: { crumb: 'Edit' } },
    ],
  },
];
